var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.myPlacementTestResults &&
      _vm.myPlacementTestResults.results &&
      _vm.myPlacementTestResults.results.length > 0
  )?_c('div',{staticClass:"myPlacementTestResults"},[_c('h3',{staticClass:"testHistoryTitle"},[_vm._v(_vm._s(_vm.$t("Your results")))]),_c('div',{staticClass:"testHistory"},_vm._l((_vm.myPlacementTestResults.results),function(ref){
      var id = ref.id;
      var score = ref.score;
      var created = ref.created;
      var placement_test_name = ref.placement_test_name;
return _c('div',{key:id,staticClass:"placementTestResultsRow"},[_c('section',[_c('span',[_vm._v(_vm._s(placement_test_name)+" - ")]),_c('span',[_vm._v("("+_vm._s(_vm.formatFromNow(created))+")")])]),_c('section',[_c('span',[_vm._v(_vm._s(score)+"%")])])])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }